import { Injectable, OnDestroy } from '@angular/core'
import { AuthService } from '@services/auth.service'
import { ChatWsEvent } from '@models/chat/chat.model'
import { IMessage } from '@stomp/stompjs'
import { Observable, Subject } from 'rxjs'
import { StompConnectionService, StompLease } from '@services/socket/stomp-connection.service'

@Injectable({ providedIn: 'root' })
export class ChatNotificationSocketService implements OnDestroy {
	private lease?: StompLease
	private stream$ = new Subject<ChatWsEvent>()

	get notifications$(): Observable<ChatWsEvent> {
		return this.stream$.asObservable()
	}

	/** Assina na conexão da aba (`StompConnectionService`), que reconecta e reassina sozinha. */
	connect(): void {
		const token = this.authService.token
		const userId = this.userIdFromToken(token)
		if (!token || !userId || (this.lease && !this.lease.closed)) return

		this.lease = this.stomp.acquire()
		// Tópico e não fila (2026-09-23): num broker externo `/queue/<nome>` vira fila com consumo
		// concorrente e duas abas do mesmo usuário dividiriam os avisos entre si.
		this.lease.subscribe(`/topic/chat.notifications.${userId}`, frame => this.forward(frame))
	}

	async disconnect(): Promise<void> {
		this.lease?.release()
		this.lease = undefined
	}

	private forward(frame: IMessage): void {
		if (!frame?.body) return

		try {
			const event = JSON.parse(frame.body) as ChatWsEvent
			this.stream$.next(event)
		} catch {
			/* noop */
		}
	}

	ngOnDestroy(): void {
		this.disconnect()
	}

	constructor(
		private authService: AuthService,
		private stomp: StompConnectionService
	) {}

	private userIdFromToken(token: string | null): string | null {
		if (!token) return null
		try {
			const payload = JSON.parse(atob(token.split('.')[1] ?? ''))
			return payload?.sub ?? null
		} catch {
			return null
		}
	}
}
